/* eslint-disable react-hooks/exhaustive-deps */
import {Col, Nav, Collapse, Button} from "react-bootstrap";
import {useState, useEffect, useRef} from "react";
import { useReactToPrint } from "react-to-print";
import TreePcg from "../components/TreePcg";
import TreePGProjects from "../components/TreePGProjects";
import RightInformation from "../components/rightInformation";
import {Resizable} from "re-resizable";
import "../styles/project.css";
import {useSelector, useDispatch} from "react-redux";
import PrintIcon from '@material-ui/icons/Print';
import {
	selectBusinessPCGCard,
	selectMeanV2,
	selectProyectV2,
	treePc,
	treeBusinessPCG,
	resetOnlyProject,
	resetOnlyClassification,
	ClassificationResourceV2,
	GraficoPCG,
	ProjectDetailsPc,
	ListarPorPeriodoGrafico,
	ListarPorPeriodoDetallesGrafico,
	ListarPorPeriodoPcDetalles,
	ListarPorPeriodoMains,
	TableMeans,
	ListarPorPeriodo,
} from "../actions/proyects.actions";
import {coinsFn} from '../actions/pcg.action';

import TreeMeansV2 from "../components/TreeMeansV2";
import LoadingModal from "../components/LoadingModal";

const Business = (props) => {
	const dispatch = useDispatch();
	const proyects = useSelector((state) => state.proyects);
	const auth = useSelector((state) => state.auth);
	const pcg = useSelector((state) => state.pcg);
	const [width, setWidth] = useState(400);
	const [height, setHeight] = useState(200);
	const [loading, setLoading] = useState(false);
	const [open, setOpen] = useState(true);
	const [secondTabData, setSecondTabData] = useState([]);
	// const [threeTabData, setThreeTabData] = useState([]);
	
	const codBusinessUrl = props.location.pathname.split("/")[2];
	const codPCGUrl = props.location.pathname.split("/")[4];
	const codMeansUrl = props.location.pathname.split("/")[6];

	const [codType] = useState('09');
	// const [urlPcg, setUrlPcg] = useState('');
	const [pesNav, setPesNav] = useState('nav1');
	const [itemsSelecteds, setItemsSelecteds] = useState({});
	const [title, setTitle] = useState('');

	const componentRef = useRef();
	const itemsSelectedsRef = useRef();

	useEffect(() => {
		itemsSelectedsRef.current = itemsSelecteds;
	}, [itemsSelecteds]);

	useEffect(() => {
		if( !pcg.coins || pcg.coins.length === 0 ) dispatch(coinsFn());
		// TODO: restart redux before call store classification
		dispatch(resetOnlyProject());
		dispatch(resetOnlyClassification());
		if( proyects.treePartyControl.length === 0 ) dispatch(treePc('', codType));
		// eslint-disable-next-line
	}, [codType]);

	const refPesNav = useRef(pesNav)
	useEffect(() => {
		refPesNav.current = pesNav;
		if ( codBusinessUrl &&  pesNav === 'nav2' && proyects.TreeProyects.length === 0) {
			dispatch(treeBusinessPCG( codType, codBusinessUrl ));
		}
		if ( codPCGUrl && pesNav === 'nav3' && proyects.treeDataTab3['Level1'] === undefined) {
			// setUrlPcg(codPCGUrl);
			dispatch(ClassificationResourceV2(codBusinessUrl, '09', codPCGUrl));
		}
	}, [pesNav])

	
	useEffect(() => {
		dispatch(resetOnlyProject());
	}, [codBusinessUrl]);

	useEffect(() => {
		dispatch(resetOnlyClassification());
	}, [codPCGUrl]);

	

	// useEffect(() => {
	// 	dispatch(treePc('', '09'));
	// }, []);

	useEffect(() => {
		setSecondTabData( proyects.TreeProyects );
	}, [proyects.TreeProyects]);

	// useEffect(() => {
	// 	// console.log(proyects.treeDataTab3)
	// 	setThreeTabData( proyects.treeDataTab3 );
	// }, [proyects.treeDataTab3]);

	const onSelectItem = (tabNumber, treeItem, headSelected = '') => {
		let items = itemsSelectedsRef.current;
		if(tabNumber !== -1) items[tabNumber] = treeItem;
		let title = 'UN';
		if(headSelected) title += ` (${headSelected})`
		for (let i = 1; i <= 3; i++) {
			if (tabNumber !== -1) {
				if ( i <= tabNumber) {
					items[i] = itemsSelectedsRef.current[i];
				} else {
					items[i] = undefined;
				}
			}
			if( items[i] !== undefined ) title += ` - ${items[i].Descripcion}`
		}
		setItemsSelecteds(items);
		setTitle(title);
	}

	const handlePrint = useReactToPrint({
		content: () => componentRef.current,
	});

	const hadlerMeansGraphic = (option = '1') => {
		dispatch(
			ListarPorPeriodoMains(codPCGUrl, codBusinessUrl, codType, codMeansUrl, option, auth.scaleSelected, auth.dateSelected)
		)
	}

	const handlerGeneralPCWithHead = (head, option = '1') => {
		if (option === '1') {
			dispatch(ListarPorPeriodoPcDetalles(
				'XXXXX002',
				codBusinessUrl,
				head,
				codType, 
				auth.dateSelected,
				auth.scaleSelected, 
			))
		} else {
			dispatch(ListarPorPeriodoDetallesGrafico(
				'XXXXX002',
				head,
				codBusinessUrl,
				codType, 
				auth.scaleSelected, 
				auth.dateSelected,
			));
		}
	}

	return (
		<>
		{loading && <LoadingModal show={true} />}
		<div className="d-flex flex-wrap justify-content-between overflow-hidden h-100">
			<Resizable
				className="tree-fixed p-0 d-flex h-100 justify-content-between"
				size={{width: width}}
				maxHeight="95vh"
				maxWidth={open ? "30vw" : 0}
				minHeight="95vh"
				minWidth={open ? "20vw" : 0}
				onResizeStop={(e, direction, ref, d) => {
					setWidth(width + d.width);
					setHeight(height + d.height);
				}}
			>
				<Collapse in={open}>
					<div className="p-2 mt-1 w-100">

						<div className="mb-2">
							
							<Nav
								variant="tabs"
								defaultActiveKey="/home"
								className="eyelashes mt-3"
							>
								<Nav.Item>
									<Nav.Link
										to="#"
										active={pesNav === "nav1"}
										onClick={() => {
											setPesNav('nav1');
										}}
									>
										Und. Negocios
									</Nav.Link>
								</Nav.Item>

								<Nav.Item>
									<Nav.Link
										to="#"
										eventKey="link-1"
										active={pesNav === "nav2"}
										onClick={() => {
											setPesNav('nav2');
										}}
									>
										PC General
									</Nav.Link>
								</Nav.Item>

								<Nav.Item>
									<Nav.Link
										to="#"
										eventKey="link-3"
										active={pesNav === "nav3"}
										onClick={() => {
											setPesNav('nav3');
										}}
									>
										Recursos
									</Nav.Link>
								</Nav.Item>

								<Nav.Item>
									<div style={{paddingLeft: 5}}>
										<Button onClick={handlePrint}><PrintIcon/></Button>
									</div>
								</Nav.Item>
							</Nav>
						
						</div>

						<div
							className="mt-2 p-2 overflow-auto"
							style={{height: "80vh"}}
						>
							
							{ pesNav === "nav1" && <TreePcg
								pesNav={pesNav}
								nodeSelected={codBusinessUrl}
								data={ proyects.treePartyControl }
								typeMoney={codType}
								urlPrefix={'/business/'}
								onSelectItem={(item) => onSelectItem(1, item)}
							/>}
							{ pesNav === "nav2" && codBusinessUrl && <TreePGProjects
								pesNav={pesNav}
								nodeSelected={codPCGUrl}
								data={ secondTabData }
								typeMoney={'09'}
								resetDate={false}
								urlPrefix={`/business/${codBusinessUrl}/pc-general/`}
								onSelectItem={(item) => onSelectItem(2, item)}
							/>}
							{pesNav === "nav3" && codPCGUrl && <TreeMeansV2
								idMeans={codMeansUrl}
								data={ proyects.treeDataTab3 }
								urlPrefix={`/business/${codBusinessUrl}/pc-general/${codPCGUrl}/recurso/`}
								onSelectItem={(item) => onSelectItem(3, item)}
								setChanges={(codInsumo, nivel, search, cleanData=false) => {
									if (cleanData) {			
										dispatch(resetOnlyClassification());
									}
									dispatch(ClassificationResourceV2(codBusinessUrl, '09', codPCGUrl, codInsumo, nivel, search))
								}}
							/>}
						</div>
					</div>
				</Collapse>
				<div
					className="bara-cerrar potencia d-flex align-items-center"
					style={{
						width: 12,
						height: "100%",
						background: "#dee2e6",
					}}
				>
					<div
						style={{cursor: "pointer"}}
						className="h-25 w-100 bg-primary d-flex align-items-center"
						onClick={() => {
							setOpen(!open);
						}}
						aria-controls="example-collapse-text"
						aria-expanded={open}
					>
						{open ? (
							<ion-icon name="caret-back-outline"></ion-icon>
						) : (
							<ion-icon name="caret-forward-outline"></ion-icon>
						)}
					</div>
				</div>
			</Resizable>

			<Col className="bigs-data px-4 w-100">
				<div className="page-break" ref={componentRef} >
					<h4 className="project-title">
						{proyects.titleProject && proyects.titleProject.split(' / ')[1] + ' - ' + proyects.titleProject.split(' / ')[2]}
					</h4>
					{pesNav === "nav1" && codBusinessUrl && <RightInformation
						codProyect={'XXXXX002'}
						codClassification={codBusinessUrl}
						codType={codType}
						cardInformationRedux={() => dispatch(selectProyectV2(codBusinessUrl, codType, auth.dateSelected, auth.scaleSelected))}
						graphicBarRedux={() => dispatch(ListarPorPeriodoGrafico('XXXXX002', codBusinessUrl, codType, auth.scaleSelected, auth.dateSelected))}
						graphicBarWithHeadRedux={(head) => handlerGeneralPCWithHead(head, '2')}
						tableDetailsRedux={() => dispatch(ProjectDetailsPc('XXXXX002', codBusinessUrl, codType, auth.scaleSelected, auth.dateSelected))}
						graphicLinesRedux={() => 
							dispatch(ListarPorPeriodo(
								'XXXXX002', 
								codBusinessUrl, 
								codType,
								auth.dateSelected,
								auth.scaleSelected,
							))}
						graphicLinesWithHeadRedux={(head) => handlerGeneralPCWithHead(head, '1')}
						changeDate={true}
						cardTitle={title}
						onSelectTableTitle={(title) => onSelectItem(-1, undefined, title)}
						handleLoading={setLoading}
					/>}
					{pesNav === "nav2" && codBusinessUrl && <RightInformation
						codProyect={codBusinessUrl}
						codClassification={codPCGUrl}
						codType={codType}
						cardInformationRedux={() => dispatch(selectBusinessPCGCard(codBusinessUrl, codPCGUrl, auth.scaleSelected, auth.dateSelected))}
						graphicBarRedux={() => dispatch(GraficoPCG(codBusinessUrl, '09', codPCGUrl, 0))}
						// graphicBarWithHeadRedux={(head) => handlerGeneralPCWithHead(head, '2')}
						tableDetailsRedux={() => dispatch(ProjectDetailsPc(codBusinessUrl, codPCGUrl, codType, auth.scaleSelected, auth.dateSelected))}
						graphicLinesRedux={() => dispatch(GraficoPCG(codBusinessUrl, '09', codPCGUrl))}
						// graphicLinesWithHeadRedux={(head) => handlerGeneralPCWithHead(head, '1')}
						refresh={refPesNav.current}
						cardTitle={title}
						onSelectTableTitle={(title) => onSelectItem(-1, undefined, title)}
						handleLoading={setLoading}
					/>}
					{pesNav === "nav3" && codMeansUrl && <RightInformation
						codProyect={codBusinessUrl}
						codClassification={codPCGUrl}
						codType={'09'}
						codMeans={codMeansUrl}
						cardInformationRedux={() => dispatch(selectMeanV2(codBusinessUrl, codPCGUrl, '09', codMeansUrl, auth.dateSelected, auth.scaleSelected))}
						graphicLinesRedux={() => hadlerMeansGraphic()}
						graphicBarRedux={() => hadlerMeansGraphic('0')}
						tableMeansRedux={() => dispatch(TableMeans(codBusinessUrl, codPCGUrl, '09', codMeansUrl, auth.scaleSelected, auth.dateSelected))}
						cardTitle={title}
						handleLoading={setLoading}
					/>}
				</div>
				
			</Col>
		</div>
		</>
	);
};

export default Business;
